import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Modal from '../components/Modal';
import { blogsAPI } from '../services/api';
import mediaPromo from '../assets/bg-mba-gamesindustrie.jpg';
import './News.css';

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('nl-NL', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
};

const getPostMedia = (post) => {
  if (Array.isArray(post?.media) && post.media.length > 0) {
    return post.media;
  }

  return post?.imageUrl
    ? [{ id: `${post.id || 'news'}-fallback`, url: post.imageUrl }]
    : [];
};

const renderPostMedia = (post, setImageModal, isFeatured = false) => {
  const media = getPostMedia(post);
  if (!media.length) return null;

  return (
    <div className={`news-media-grid${isFeatured ? ' is-featured' : ''}`}>
      {media.map((image, index) => (
        <button
          key={image.id || `${post.id}-${index}`}
          type="button"
          className={`news-image-button${isFeatured && index === 0 ? ' news-image-button-featured' : ''}`}
          onClick={() => setImageModal({
            isOpen: true,
            url: image.url,
            title: `${post.title || 'Nieuws afbeelding'} (${index + 1}/${media.length})`
          })}
        >
          <img src={image.url} alt={`${post.title || 'Nieuws afbeelding'} ${index + 1}`} className="news-image" />
        </button>
      ))}
    </div>
  );
};

const News = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [imageModal, setImageModal] = useState({ isOpen: false, url: '', title: '' });

  useEffect(() => {
    let isMounted = true;

    const loadNews = async () => {
      setLoading(true);
      setError('');
      try {
        const response = await blogsAPI.getPublic({ limit: 100 });
        if (isMounted) {
          setPosts(response.posts || []);
        }
      } catch (loadError) {
        if (isMounted) {
          setError(loadError.message || 'Nieuws ophalen mislukt');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadNews();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="news-page">
      <Navbar />

      <section className="news-hero">
        <div className="news-hero-inner">
          <h1>Nieuws</h1>
          <p>Actuele updates, aankondigingen en verhalen van NLBA Suriname.</p>
        </div>
      </section>

      <section className="news-content">
        <div className="news-content-inner">
          <div className="news-promo-row">
            <div className="news-promo-copy">
              <h2>Wat zijn de nieuwste ontwikkelingen bij NLBA?</h2>
              <p>
                Volg updates over opleidingen, events, startmomenten en studentverhalen.
                Alle berichten hieronder worden beheerd vanuit de backend door het NLBA-team.
              </p>
            </div>
            <img src={mediaPromo} alt="NLBA updates" className="news-promo-image" loading="lazy" />
          </div>

          {loading && <p>Nieuws laden...</p>}
          {error && <p className="news-error">{error}</p>}

          {!loading && !error && posts.length === 0 && (
            <p className="news-empty">Er zijn nog geen nieuwsberichten gepubliceerd.</p>
          )}

          {!loading && !error && posts.length > 0 && (
            <>
              <article className="news-featured-card">
                <div className="news-meta">
                  <span>{formatDate(posts[0].publishedAt)}</span>
                  {posts[0].location && <span>{posts[0].location}</span>}
                </div>
                <h2>{posts[0].title}</h2>
                {posts[0].summary && <p className="news-summary">{posts[0].summary}</p>}
                {renderPostMedia(posts[0], setImageModal, true)}
                <div className="news-body" dangerouslySetInnerHTML={{ __html: posts[0].content }} />
              </article>

              {posts.length > 1 && (
                <div className="news-grid">
                  {posts.slice(1).map((post) => (
                    <article className="news-card" key={post.id}>
                      <div className="news-meta">
                        <span>{formatDate(post.publishedAt)}</span>
                        {post.location && <span>{post.location}</span>}
                      </div>
                      <h3>{post.title}</h3>
                      {post.summary && <p className="news-summary">{post.summary}</p>}
                      {renderPostMedia(post, setImageModal)}
                      <div className="news-body" dangerouslySetInnerHTML={{ __html: post.content }} />
                    </article>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </section>

      <Footer />

      <Modal
        isOpen={imageModal.isOpen}
        onClose={() => setImageModal({ isOpen: false, url: '', title: '' })}
        title={imageModal.title}
        size="lg"
      >
        {imageModal.url && (
          <img
            src={imageModal.url}
            alt={imageModal.title || 'Nieuws afbeelding'}
            style={{ width: '100%', maxHeight: '75vh', objectFit: 'contain', borderRadius: '10px' }}
          />
        )}
      </Modal>
    </div>
  );
};

export default News;
